import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';
import { getCalendarPosition } from '../misc/calendarPosition';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export class MandatePeriod extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            this.Start = utility.parseDate(this.Start);
            this.End = utility.parseDate(this.End);
            this.display = utility.formatDate(this.Start) + " - " + utility.formatDate(this.End);
            this.calendarPosition = getCalendarPosition(this.Start, this.End);
        }
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Organization = ctx.getOrganization(this.OrganizationId);
    }

    toJSON() {
        var ret = super.toJSON();
        ret.OrganizationId = BaseObject.withRelated(ret, "Organization");
        return ret;
    }
}
